import React from "react";
export default function Profile() {

    return (
        <div className='home_contenedor'>
            <iframe width="100%" height="100%" title="This is a unique title" src={`https://loads-pro.sostruckingsoftware.com/soiltech/pwa/1.3/_services/driver_card.php?id=${localStorage.getItem("token")}`} />
        </div>
    )

}